import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=8d048856&scoped=true&"
var script = {}
import style0 from "./NoResult.vue?vue&type=style&index=0&id=8d048856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d048856",
  null
  
)

export default component.exports